import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'striphtml'
})

export class StripHtmlPipe implements PipeTransform {
    transform(value: string, escape: boolean = false): any {
        if (escape) {
            return value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        } else {
            // replace br with newlines + replace p with 2x newlines
            return value.replace(/br\>|br\/\>|br \/\>/gi,"\n").replace(/\<\/p\>/gi,"\n\n").replace(/<.*?>/g, ''); // replace tags
        }
    }
}